import { render } from "./success.vue?vue&type=template&id=ef87df66&ts=true"
import script from "./success.vue?vue&type=script&lang=ts"
export * from "./success.vue?vue&type=script&lang=ts"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__